import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Wrapper from './styled/Wrapper';
import Line from './styled/Line';
import Label from './styled/Label';

export default class ArrowButton extends PureComponent {

  static defaultProps = {};

  state = {
    isHovered: false,
  };

  onMouseEnter = () => {
    this.setState({ isHovered: true });
  };

  onMouseLeave = () => {
    this.setState({ isHovered: false });
  };

  render() {
    const { className, prev, label, ...restProps } = this.props;
    const { isHovered } = this.state;

    return (
      <Wrapper
        className={className}
        prev={prev}
        {...restProps}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        <Label animate={{ x: isHovered ? (prev ? 10 : -10) : 0 }}>{label}</Label>
        <Line />
      </Wrapper>
    );
  }
}
